import { render, staticRenderFns } from "./SignUpSuccess.vue?vue&type=template&id=4ab39470"
import script from "./SignUpSuccess.vue?vue&type=script&lang=js"
export * from "./SignUpSuccess.vue?vue&type=script&lang=js"
import style0 from "./SignUpSuccess.vue?vue&type=style&index=0&id=4ab39470&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports